<form [formGroup]="addOrEditForm" class="tablelist-form" autocomplete="off">
  <label for="reportID-field" class="form-label">Report</label>
  <select class="form-select" name="reportID-field" id="reportID-field" formControlName="reportID" (change)="selectOnChange($event)">
    <option selected></option>
    @for (object of getDropdownDataObjectArray(); track object.id) {
      <option [ngValue]="object.id">{{object.description}}</option>    
    }
  </select>
</form>
